/* tslint:disable */
/* eslint-disable */
/**
 * Toki Public APIs
 * API Gateway for all Toki Public APIs
 *
 * The version of the OpenAPI document: 4.8.7
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ConsumerCustomerTypeEnum = {
    Company: 'company',
    Person: 'person'
};
/**
 * Check if a given object implements the ConsumerCustomer interface.
 */
export function instanceOfConsumerCustomer(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('type' in value) || value['type'] === undefined)
        return false;
    return true;
}
export function ConsumerCustomerFromJSON(json) {
    return ConsumerCustomerFromJSONTyped(json, false);
}
export function ConsumerCustomerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'id': json['id'],
        'secondaryId': json['secondary_id'] == null ? undefined : json['secondary_id'],
        'type': json['type'],
        'representatives': json['representatives'] == null ? undefined : json['representatives'],
    };
}
export function ConsumerCustomerToJSON(json) {
    return ConsumerCustomerToJSONTyped(json, false);
}
export function ConsumerCustomerToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'id': value['id'],
        'secondary_id': value['secondaryId'],
        'type': value['type'],
        'representatives': value['representatives'],
    };
}
